(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[580],{

/***/ 352:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/[id]",
      function () {
        return __webpack_require__(7100);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9989);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5302);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-grow: 1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Spacer = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (Spacer);


/***/ }),

/***/ 2125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ toMaterialShade; }
/* harmony export */ });
/* unused harmony export makeMaterialPalette */
/* harmony import */ var colord__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1939);

/**
 * Given a primary color (500), generate a full material design color
 * palette using colord.
 */ var makeMaterialPalette = function(mainColor) {
    var main = (0,colord__WEBPACK_IMPORTED_MODULE_0__/* .colord */ .Vi)(mainColor);
    return {
        "50": main.lighten(0.35).toHex(),
        "100": main.lighten(0.25).toHex(),
        "200": main.lighten(0.18).toHex(),
        "300": main.lighten(0.12).toHex(),
        "400": main.lighten(0.06).toHex(),
        "500": main.toHex(),
        "600": main.darken(0.06).toHex(),
        "700": main.darken(0.12).toHex(),
        "800": main.darken(0.18).toHex(),
        "900": main.darken(0.25).toHex(),
        // Accents have a slightly rotated hue
        A100: main.rotate(5).lighten(0.24).toHex(),
        A200: main.rotate(5).lighten(0.16).toHex(),
        A400: main.rotate(5).darken(0.1).toHex(),
        A700: main.rotate(5).darken(0.12).toHex()
    };
};
/**
 * Given a primary color (500), compute the color at
 * the specified Material Design shade (e.g. 50, 700, A100)
 */ var toMaterialShade = function(primaryColor, materialShade) {
    var palette = makeMaterialPalette(primaryColor);
    return palette[materialShade];
};


/***/ }),

/***/ 2781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E5": function() { return /* binding */ APP_BASE_URL; }
/* harmony export */ });
/* unused harmony exports TAKO_SERVER, PHOENIX_SERVER */
// The NEXT_PUBLIC_ prefix is similar to the REACT_APP_ prefix from create-react-app
/**
 * Base URL of the Next.js app, e.g. http://localhost:3000 or https://share.hypotenuse.ai
 */ var APP_BASE_URL = "https://share.hypotenuse.ai";
/**
 * Tako server URL
 */ var TAKO_SERVER = (/* unused pure expression or super */ null && ("https://app.hellotako.com"));
/**
 * Phoenix server URL
 */ var PHOENIX_SERVER = (/* unused pure expression or super */ null && ("https://app.hypotenuse.ai"));


/***/ }),

/***/ 9836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ articlePreview_ArticlePreview; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(5310);
// EXTERNAL MODULE: ../node_modules/@mui/material/Button/Button.js + 13 modules
var Button = __webpack_require__(7142);
// EXTERNAL MODULE: ../node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(5283);
// EXTERNAL MODULE: ../node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(2750);
// EXTERNAL MODULE: ../node_modules/@mui/material/AppBar/AppBar.js + 3 modules
var AppBar = __webpack_require__(2983);
// EXTERNAL MODULE: ../node_modules/@mui/material/Toolbar/Toolbar.js + 1 modules
var Toolbar = __webpack_require__(2384);
// EXTERNAL MODULE: ../node_modules/@mui/material/Container/Container.js + 2 modules
var Container = __webpack_require__(309);
// EXTERNAL MODULE: ../node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(2709);
// EXTERNAL MODULE: ../node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(4776);
// EXTERNAL MODULE: ../node_modules/@mui/icons-material/ArrowForward.js
var ArrowForward = __webpack_require__(7210);
// EXTERNAL MODULE: ../common/src/components/atoms/Spacer.tsx
var Spacer = __webpack_require__(2162);
// EXTERNAL MODULE: ./lib/hooks/useIsMobile.tsx
var useIsMobile = __webpack_require__(2165);
// EXTERNAL MODULE: ../common/src/utils/ColorUtils.ts
var ColorUtils = __webpack_require__(2125);
// EXTERNAL MODULE: ../node_modules/@mui/material/Divider/Divider.js + 1 modules
var Divider = __webpack_require__(5520);
// EXTERNAL MODULE: ../node_modules/@mui/icons-material/esm/FormatBold.js
var FormatBold = __webpack_require__(8299);
// EXTERNAL MODULE: ../node_modules/@mui/icons-material/esm/FormatItalic.js
var FormatItalic = __webpack_require__(5351);
// EXTERNAL MODULE: ../node_modules/@mui/icons-material/esm/FormatAlignLeft.js
var FormatAlignLeft = __webpack_require__(4121);
// EXTERNAL MODULE: ../node_modules/@mui/icons-material/esm/FormatAlignCenter.js
var FormatAlignCenter = __webpack_require__(4999);
// EXTERNAL MODULE: ../node_modules/@mui/icons-material/esm/FormatAlignRight.js
var FormatAlignRight = __webpack_require__(9521);
// EXTERNAL MODULE: ../node_modules/@mui/icons-material/esm/FormatAlignJustify.js
var FormatAlignJustify = __webpack_require__(5869);
// EXTERNAL MODULE: ../node_modules/xss/lib/index.js
var lib = __webpack_require__(1719);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./components/editor/DummyEditor.tsx





/**
 * A dummy editor component that displays read-only rich content in a div when
 * given raw HTML (don't worry - we sanitize it first).
 */ var DummyEditor = function(props) {
    var _dangerousHtmlContent = props.htmlContent, showToolbar = props.showToolbar;
    var theme = (0,useTheme/* default */.Z)();
    var sanitizedHtmlContent = lib_default()(_dangerousHtmlContent);
    var editorToolbar = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        direction: "row",
        spacing: 2,
        color: theme.palette.action.disabled,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatBold/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatItalic/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatAlignLeft/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatAlignCenter/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatAlignRight/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatAlignJustify/* default */.Z, {})
        ]
    });
    // Note: We're not currently using a real editor component but instead
    //  mocking it with a div in the interest of time.
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        spacing: 2,
        p: 2,
        border: "1px solid rgba(0, 0, 0, 0.1)",
        borderRadius: 1,
        style: {
            backgroundColor: "white"
        },
        children: [
            showToolbar && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    editorToolbar,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        variant: "middle"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    // Use this prop with great caution. Any value passed here should
                    //  be sanitized first.
                    // See https://stackoverflow.com/questions/37337289/react-js-set-innerhtml-vs-dangerouslysetinnerhtml
                    __html: sanitizedHtmlContent
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/articlePreview/ArticlePreview.tsx









var InfoChip = (0,styled/* default */.ZP)(Box/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        color: theme.palette.primary.main,
        backgroundColor: (0,ColorUtils/* toMaterialShade */.G)(theme.palette.primary.main, 50),
        borderRadius: theme.shape.borderRadius
    };
});
/**
 * URL query parameters for campaign tracking.
 * Note that these should only be present in production, not
 *  in development or staging.
 *
 */ var UTM_PARAMS = new URLSearchParams({
    utm_source: "blogshare",
    utm_medium: "banner",
    utm_campaign: "blog_linkshare"
});
/**
 * URL To redirect to when the user clicks a call-to-action button.
 */ var CALL_TO_ACTION_URL = "https://www.hypotenuse.ai/ai-article-writer?".concat(UTM_PARAMS);
var LANDING_PAGE_URL = "https://www.hypotenuse.ai?".concat(UTM_PARAMS);
/**
 * Text transform applied to HTML article content.
 * Currently used to remove <p>&nbsp;</p> tags
 */ var _transformHtmlContent = function(content, title) {
    var strippedContent = content.replace(/<p>&nbsp;<\/p>/g, "\n");
    return "<h1>".concat(title, "</h1>").concat(strippedContent);
};
/**
 * Static mockup of the publicly viewable article preview page.
 * May change to include dynamic components in the future.
 */ var ArticlePreview = function(props) {
    var articlePreview = props.articlePreview, _logoProp = props.logo;
    var theme = (0,useTheme/* default */.Z)();
    var isMobile = (0,useIsMobile/* default */.Z)();
    var ref = articlePreview !== null && articlePreview !== void 0 ? articlePreview : {}, articleHtmlContent = ref.html_content, authorName = ref.author_display_name, title = ref.title;
    // ==== Appbar contents ====
    var logo = /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: LANDING_PAGE_URL,
        children: _logoProp
    });
    /**
   * CTA button displayed at the very top of the page
   */ var navbarCtaButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        component: "a",
        href: CALL_TO_ACTION_URL,
        target: "_blank",
        rel: "noopener noreferrer",
        color: "primary",
        variant: "contained",
        endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {}),
        children: "Try it yourself"
    });
    var mobileAppBarContent = // Logo in appbar should be centered on mobile
    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        flex: 1,
        direction: "row",
        justifyContent: "center",
        children: logo
    });
    var desktopAppBarContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            logo,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacer/* default */.Z, {}),
            navbarCtaButton
        ]
    });
    var appBarContent = isMobile ? mobileAppBarContent : desktopAppBarContent;
    // ==== Author info ====
    var displayAuthorChip = authorName !== "an anonymous user";
    var authorChipText = "Published by ".concat(authorName);
    var mobileAuthorChip = /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        px: 1,
        py: 0.5,
        borderRadius: 1,
        borderColor: theme.palette.primary.main,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            component: "div",
            align: "center",
            color: "primary",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                fontWeight: 700,
                fontSize: "0.875rem",
                children: authorChipText
            })
        })
    });
    var desktopAuthorChip = /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        px: 1,
        py: 0.5,
        borderRadius: 1,
        bgcolor: theme.palette.primary.main,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            component: "div",
            align: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                color: theme.palette.getContrastText(theme.palette.primary.main),
                fontWeight: 500,
                fontSize: "0.875rem",
                children: authorChipText
            })
        })
    });
    var authorChip = displayAuthorChip ? isMobile ? mobileAuthorChip : desktopAuthorChip : null;
    var infoChipText = "This article was written and edited with AI.";
    var mobileInfoChip = /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoChip, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            spacing: 1,
            p: 1,
            children: [
                authorChip,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    align: "center",
                    children: infoChipText
                })
            ]
        })
    });
    var desktopInfoChip = /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoChip, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            direction: "row",
            p: displayAuthorChip ? undefined : 1,
            pr: 1,
            spacing: 1,
            alignItems: "center",
            children: [
                authorChip,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: infoChipText
                    })
                })
            ]
        })
    });
    var infoChip = isMobile ? mobileInfoChip : desktopInfoChip;
    // ==== CTA button ====
    /**
   * Call-to-action button displayed in banner above the article content
   */ var mobileBannerCtaButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        component: "a",
        href: CALL_TO_ACTION_URL,
        target: "_blank",
        rel: "noopener noreferrer",
        variant: "contained",
        color: "primary",
        endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {}),
        children: "Try it yourself"
    });
    var desktopBannerCtaButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        component: "a",
        href: CALL_TO_ACTION_URL,
        target: "_blank",
        rel: "noopener noreferrer",
        variant: "text",
        color: "primary",
        endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {}),
        children: "Learn more"
    });
    var bannerCtaButton = isMobile ? mobileBannerCtaButton : desktopBannerCtaButton;
    // ==== Banner ====
    var mobileBanner = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        sx: {
            color: theme.palette.primary.main
        },
        width: "100%",
        spacing: 1,
        children: [
            infoChip,
            bannerCtaButton
        ]
    });
    var desktopBanner = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        sx: {
            color: theme.palette.primary.main
        },
        direction: "row",
        alignItems: "center",
        width: "100%",
        px: 2,
        py: 1,
        borderRadius: 1,
        border: 1,
        children: [
            infoChip,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacer/* default */.Z, {}),
            bannerCtaButton
        ]
    });
    var banner = isMobile ? mobileBanner : desktopBanner;
    var editor = /*#__PURE__*/ (0,jsx_runtime.jsx)(DummyEditor, {
        htmlContent: _transformHtmlContent(articleHtmlContent !== null && articleHtmlContent !== void 0 ? articleHtmlContent : "", title !== null && title !== void 0 ? title : "")
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBar/* default */.Z, {
                sx: {
                    backgroundColor: theme.palette.grey[900]
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Toolbar/* default */.Z, {
                    children: appBarContent
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Toolbar/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: "md",
                style: {
                    height: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    pt: {
                        xs: 3,
                        md: 6
                    },
                    pb: 3,
                    spacing: 2,
                    alignItems: "center",
                    children: [
                        banner,
                        editor
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var articlePreview_ArticlePreview = (ArticlePreview);


/***/ }),

/***/ 7872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7486);
/* harmony import */ var _Constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2781);




var ArticlePreviewSEO = function(props) {
    var articlePreview = props.articlePreview;
    var title = articlePreview.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
        title: title,
        description: "Get an entire blog post written in minutes with AI.",
        openGraph: {
            title: title,
            url: "".concat(_Constants__WEBPACK_IMPORTED_MODULE_3__/* .APP_BASE_URL */ .E5, "/article/").concat(articlePreview.id),
            type: "article",
            images: [
                {
                    url: "".concat(_Constants__WEBPACK_IMPORTED_MODULE_3__/* .APP_BASE_URL */ .E5, "/opengraph_preview.png")
                }
            ]
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticlePreviewSEO);


/***/ }),

/***/ 8917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ logos_HypotenuseLogoText; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(9722);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
;// CONCATENATED MODULE: ../platform/src/assets/hypotenuse_logo_text_light.svg
/* harmony default export */ var hypotenuse_logo_text_light = ({"src":"/_next/static/media/hypotenuse_logo_text_light.528e87d3.svg","height":28,"width":212});
;// CONCATENATED MODULE: ../platform/src/assets/hypotenuse_logo_text_dark.svg
/* harmony default export */ var hypotenuse_logo_text_dark = ({"src":"/_next/static/media/hypotenuse_logo_text_dark.16814fb4.svg","height":28,"width":212});
// EXTERNAL MODULE: ../node_modules/next/image.js
var next_image = __webpack_require__(8579);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/logos/HypotenuseLogoText.tsx







/**
 * Logo on the left, name on the right.
 * This component uses NextJS's Image component for optimized image loading.
 */ var HypotenuseLogoText = function(props) {
    var light = props.light, rest = _objectWithoutProperties(props, [
        "light"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({
        src: light ? hypotenuse_logo_text_light : hypotenuse_logo_text_dark,
        height: "32px",
        alt: "Hypotenuse AI logo"
    }, rest));
};
/* harmony default export */ var logos_HypotenuseLogoText = (HypotenuseLogoText);


/***/ }),

/***/ 2165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getMobileBreakpoint */
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4776);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8181);

/**
 * Definition of the mobile breakpoint.
 */ var getMobileBreakpoint = function(theme) {
    return theme.breakpoints.down("sm");
};
/**
 * MUI v5 port of the useIsMobile hook from @hypotenuse/common/src/hooks
 *
 * Centralized utility hook for checking whether the viewport width
 *  is equal to or smaller than the 'mobile' breakpoint.
 */ var useIsMobile = function() {
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    return (0,_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(getMobileBreakpoint(theme));
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsMobile);


/***/ }),

/***/ 7100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _components_articlePreview_ArticlePreview__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9836);
/* harmony import */ var _components_logos_HypotenuseLogoText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8917);
/* harmony import */ var _components_articlePreview_ArticlePreviewSEO__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7872);





/**
 * Publicly viewable article preview page
 */ var PhoenixArticlePreviewPage = function(props) {
    var articlePreview = props.articlePreview;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_articlePreview_ArticlePreviewSEO__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                articlePreview: articlePreview
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_articlePreview_ArticlePreview__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                articlePreview: articlePreview,
                logo: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_logos_HypotenuseLogoText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    light: true,
                    priority: true
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (PhoenixArticlePreviewPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [921,663,774,888,179], function() { return __webpack_exec__(352); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);